const searchParamsFromObject = (obj) => {
  const params = new URLSearchParams(obj);
  const keysForDel = [];
  params.forEach((value, key) => {
    if (!value) {
      keysForDel.push(key);
    }
  });

  keysForDel.forEach(key => {
    params.delete(key);
  });
  return params.toString();
}

const renderLoremIpsum = (wordsCount) => {
  const words = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum'.split(' ')
  let result = ''
  for (let i = 0; i < wordsCount; i++) {
    result += words[i % words.length] + ' '
  }
  return result
}

export { searchParamsFromObject, renderLoremIpsum }